<template>
  <div class="manage-default-box">
    <div class="main-box clear-both">
      <LeftNav :status='4'></LeftNav>
      <div class="download-display">
        <h2>ダウンロード</h2>
        <div class="download-info-box">
          <p class="title">注文履歴（期間）</p>
          <div class="download-info-sub-box">
            <p class="description">1か月のみダウンロードする場合は、開始と終了を同じ年月に指定してください。</p>
            <div class="order-term-box">
              <input type="text" class="order-year" placeholder="例）1900" maxlength="4" v-model="start_year">
              <p>年</p>
              <input type="text" class="order-month" placeholder="1" maxlength="2" v-model="start_month">
              <p>月</p>
              <p class="from">～</p>
              <input type="text" class="order-year" placeholder="例）1900" maxlength="4" v-model="end_year">
              <p>年</p>
              <input type="text" class="order-month" placeholder="2" maxlength="2" v-model="end_month">
              <p>月</p>
            </div>
            <button @click="order_download">CSVダウンロード</button>
          </div>
          <hr />
          <p class="title">会員</p>
          <div class="download-info-sub-box">
            <button @click="member_download">CSVダウンロード</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/views/components/manage/LeftNav';

export default {
  name: 'manageDefault',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftNav,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      start_year: '',
      start_month: '',
      end_year: '',
      end_month: '',
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    const today = new Date();
    today.setDate(1);
    today.setMonth(today.getMonth() - 1);
    this.start_year = today.getFullYear();
    this.start_month = today.getMonth() + 1;
    this.end_year = today.getFullYear();
    this.end_month = today.getMonth() + 1;
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    order_download () {
      // 入力チェック
      if (this.start_year === '' ||
        this.start_month === '' ||
        this.end_year === '' ||
        this.end_month === '') {
        this.$alert('alert', '注文履歴の開始期間、終了期間を入力してください。');
        return;
      }
      // 数値チェック
      const num_reg = new RegExp(/^[0-9]{1,}$/);
      if (String(this.start_year).match(num_reg) === null ||
        String(this.start_month).match(num_reg) === null ||
        String(this.end_year).match(num_reg) === null ||
        String(this.end_month).match(num_reg) === null) {
        this.$alert('alert', '注文履歴の開始期間、終了期間は数値のみを入力してください。');
        return;
      }
      // 月の数値チェック
      const s_month = this.$lib._pint(this.start_month);
      const e_month = this.$lib._pint(this.end_month);
      if ((s_month <= 0 || s_month > 12) ||
        (e_month <= 0 || e_month > 12)) {
        this.$alert('alert', '注文履歴の開始期間、終了期間の月が正しくありません。');
        return;
      }
      // 開始、終了チェック
      const s_ym = this.$lib._pint(String(this.start_year) + this.$lib._zero_add(s_month));
      const e_ym = this.$lib._pint(String(this.end_year) + this.$lib._zero_add(e_month));
      if (s_ym > e_ym) {
        this.$alert('alert', '注文履歴の開始期間は終了期間と同じか過去に設定してください。');
        return;
      }
      this.$lib._download_start('manage/order_download.php',
        {token: this.$store.getters['mLoginInfo/login_token'],
          start_ym: s_ym,
          end_ym: e_ym});
    },

    member_download () {
      this.$lib._download_start('manage/member_download.php',
        {token: this.$store.getters['mLoginInfo/login_token']});
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-default-box {
  .download-display {
    min-width: 1108px;
    flex: 1;
    padding: 16px;

    .download-info-box {
      width: 900px;
      margin: 20px auto 0 auto;

      hr {
        height: 1px;
        background-color: #deddc8;
        border: none;
        color: #deddc8;
        margin: 20px 0;
      }

      .title {
        text-align: left;
        font-size: 1.2rem;
        font-weight: bold;
      }

      .download-info-sub-box {
        margin-left: 20px;

        .description {
          text-align: left;
          color: #888;
          margin-top: 5px;
        }

        .order-term-box {
          display: flex;
          margin-top: 10px;

          .order-year {
            width: 100px;
            text-align: right;
          }

          .order-month {
            width: 80px;
            text-align: right;
          }

          p {
            width: 30px;
            height: 30px;
            line-height: 30px;
          }

          p.from {
            margin: 0 15px;
            font-size: 1.3rem;
          }
        }
        button {
          display: block;
          outline: 0;
          margin: 20px 0 ;
          border: none;
          color: #FFF;
          width: 300px;
          height: 40px;
          font-weight: bold;
          font-size: 1.2rem;
          border-radius: 5px;
          cursor: pointer;
        }

      }
    }
  }
}
</style>
